import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

// Custom Inputs
import CustomDialog from './inputs/CustomDialog'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import DateInput from './inputs/DateInput'
import InnerBar from './InnerBar';
import FormSelect from './inputs/FormSelect'
import MetaBox from './inputs/MetaBox'
import TextInput from './inputs/TextInput'

import {
  is_logged_on,
  is_validating,
  capitalize,
  theme
} from "../helpers"

 import {
   LocalForm,
   Control,
   actions
} from 'react-redux-form'

import {
  isRequired,
  isNumeric
} from "../validators"

import {
  get_coupon,
  preferences_index,
  businesses_select,
  create_coupon,
  update_coupon,
  reset_coupon,
  clear_coupon,
} from '../actions'

const mapStateToProps = state => {
  const { coupon, errors, fetching_single, fetched_single, must_redirect } = state.coupon
  return {
    coupon,
    errors,
    fetching_single,
    fetched_single,
    must_redirect,
    current_user: state.auth.current_user.data,
    businesses: state.business.select_items,
    preferences: state.preference.preferences
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCoupon: coupon_id => dispatch( get_coupon(coupon_id) ),
    createCoupon: values => dispatch( create_coupon(values) ),
    updateCoupon: (coupon_id, values) => dispatch( update_coupon(coupon_id, values) ),
    getPreferences: () => dispatch( preferences_index() ),
    getBusinesses: () => dispatch( businesses_select() ),
    resetCoupon: () => dispatch( reset_coupon() ),
    clearCoupon: () => dispatch( clear_coupon() ),
  };
};

class ConnectedCouponForm extends React.Component {
  state = {
    actionName: '',
    nameValid: true,
    descriptionValid: true,
    discountValid: true,
    limitValid: true,
    valid_from: null,
    valid_fromValid: true,
    valid_to: null,
    valid_toValid: true,

    business: '',
    businessChanged: false,

    formData: null,
    publish: false, // bind to action
    trash: false, // bind to action

    showDialog: false,
    showRevokeDialog: false,
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  checkValid() {
    this.formDispatch( actions.setDirty('coupon.name') )
    this.formDispatch( actions.setDirty('coupon.description') )
    this.formDispatch( actions.setDirty('coupon.limit') )
    this.formDispatch( actions.setDirty('coupon.discount') )
    this.formDispatch( actions.setDirty('coupon.valid_from') )
    this.formDispatch( actions.setDirty('coupon.valid_to') )

    const isValid = this.state.formData.$form.valid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  handleSubmit(inValues) {
    let values = {
      ...inValues
    }
    if (this.state.publish) {
      values={
        ...inValues,
        publish: true,
        index: false
      }
    } else if (this.state.revoke) {
      values={
        ...inValues,
        revoke: true,
        index: false
      }
    }

    if (this.state.actionName === "create") {
      this.props.createCoupon(values)
    } else {
      const { coupon_id } = this.props
      this.props.updateCoupon(coupon_id, values)
    }
  }

  handleUpdate(form) {
    const { name, description, discount, limit, valid_from, valid_to } = form
    this.setState({formData: form})

    const new_name = name.value.toString().toUpperCase().replace(/([^a-zA-Z0-9_])/,"").replace(/_+/, "_").replace(/^_/,"")
    if (name.value !== new_name) {
      this.formDispatch( actions.change('coupon.name', new_name) )
    }

    this.setState({
      nameValid: (name.pristine || name.valid),
      descriptionValid: (description.pristine || description.valid),
      discountValid: (discount.pristine || discount.valid),
      limitValid: (limit.pristine || limit.valid),
      valid_fromValid: (valid_from.pristine || valid_from.valid),
      valid_toValid: (valid_to.pristine || valid_to.valid)
    })
  }

  onChangeFrom(date) {
    if (date !== null) {
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
    }
    this.setState({valid_from: date})
    this.formDispatch( actions.change('coupon.valid_from', date) )
  }

  onChangeTo(date) {
    if (date !== null) {
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
    }
    this.setState({valid_to: date})
    this.formDispatch( actions.change('coupon.valid_to', date) )
  }

  resetView() {
    const { actionName } = this.props
    const { clearCoupon, coupon, getCoupon, getPreferences, preferences } = this.props
    clearCoupon()
    this.setState({ actionName, businessChanged: false })
    if ( !preferences.test_price ) {
      getPreferences()
    }
    if ( actionName === 'update') {
      const { coupon_id } = this.props
      if ( coupon.id !== coupon_id ) {
        getCoupon(coupon_id)
      }
    }
  }

  componentWillMount() {
    this.resetView()
    this.props.getBusinesses()
  }

  componentWillUpdate(prevProps, prevState) {
    const { actionName } = this.props
    if (this.state.actionName !== actionName ) {
      return this.resetView()
    }

    if ( actionName === 'update' && !this.state.businessChanged ) {
      if ( this.state.business === '' && this.props.coupon.business_id ) {
        this.setState({ business: this.props.coupon.business_id, businessChanged: true })
      }
    }

    if (this.props.must_redirect && !prevProps.must_redirect) {
      window.showSnackbar('success', 'Coupon has been saved.')
    }
  }

  hideDialog() {
    this.setState({showDialog: false, showRevokeDialog: false})
  }

  handlePublish() {
    this.props.resetCoupon()
    this.setState({publish: true, revoke: false, showDialog: false})
    this.formDispatch(actions.submit('coupon'))
  }

  handleRevoke() {
    this.props.resetCoupon()
    this.setState({publish: false, revoke: true, showRevokeDialog: false})
    this.formDispatch(actions.submit('coupon'))
  }

  handleChangeBusiness(e) {
    const { value } = e.target
    if (value) {
      this.formDispatch(actions.change('coupon.business_id', value))
      this.setState({business: value})
    } else {
      this.formDispatch(actions.change('coupon.business_id', ''))
      this.setState({business: ''})
    }
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { actionName, must_redirect } = this.props

    if ( actionName === 'create' && this.props.must_redirect && this.props.coupon.id ) {
      return <Redirect to={`/coupons/${this.props.coupon.id}/edit`} />
    }

    if ( actionName === 'update' && !this.props.coupon.id ) {
      return ''
    }

    const maxPriceOff = this.props.preferences.test_price

    if ( !maxPriceOff ) {
      return ''
    }

    if (must_redirect && this.state.publish) {
      window.showSnackbar('success', 'The coupon status has changed to: Published.')
      return (
        <Redirect to="/coupons" />
      )
    } else if (must_redirect && this.state.revoke) {
      window.showSnackbar('success', 'The coupon status has changed to: Revoked.')
      return (
        <Redirect to="/coupons" />
      )
    }

    const {
      name, description, discount, value, limit, usage,
      valid_from, valid_to, status, id, longid,
      created_at, updated_at, published_on, creator,
      business_id, business_name, vouchers, active_vouchers, consumed_vouchers, campaign_token
    } = this.props.coupon

    let initialState
    if (actionName === "create") {
      initialState = {
        name: '',
        description: '',
        discount: '',
        limit: 0,
        valid_from: null,
        valid_to: null
      }
    } else {
      initialState = {
        discount: (discount > 0) ? `${parseInt(discount * 100, 10)} %` : value,
        name,
        description,
        limit,
        valid_from,
        valid_to
      }
    }

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          disabled={false && !this.state.formValid}
          onClick={e => {
            e.preventDefault()
            this.setState({publish: false, trash: false})
            this.checkValid()
            this.formDispatch( actions.submit('coupon'))
          }}>Save</CustomOutlinedButton>
      </div>
    )

    const state_business = this.state.business

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={24} justify="space-between">

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <div className="d-flex justify-content-between mb-40">
              <Typography className="fw-bold h4">
                {this.props.headTitle || "Coupon"}
              </Typography>

              { actionButtons }

            </div>
          </Grid>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <LocalForm
              model="coupon"
              className="collection-item"
              initialState={initialState}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onUpdate={(form) => this.handleUpdate(form)}
              onSubmit = {(values) => this.handleSubmit(
                {
                  ...values,
                  business_id: state_business,
                }
              )}
            >

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="Coupon Data" />
                <div className="pl-24 pr-24 pt-24 pb-24">

                  <Typography className="h6 mt-32 mb-12">Coupon Name</Typography>
                  <TextInput
                    id="coupon-name"
                    model="coupon.name"
                    required
                    placeholder="Coupon ID, no spaces, Caps only"
                    helperText="Required Field *"
                    error={!this.state.nameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                  <Typography className="h6 mt-32 mb-12">Business Name</Typography>
                  <Control.select
                    model="wathe"
                    id="coupon-business"
                    value={state_business}
                    label="Select Business"
                    inputProps= {{className: 'input-pl16'}}
                    component={FormSelect}
                    helperText="Coupon will be exclusive to selected Business"
                    className="w-100 label-pl16"
                    onChange={(e) => this.handleChangeBusiness(e)}
                  >
                    <MenuItem value={''} className="blank_selection">Select a business</MenuItem>
                    {
                      this.props.businesses.map( s => {
                        return <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                      })
                    }
                  </Control.select>

                  <Typography className="h6 mt-32 mb-12">Description</Typography>
                  <TextInput
                    id="coupon-description"
                    model="coupon.description"
                    required
                    placeholder="Internal use only, not visible to test taker"
                    helperText="Required Field *"
                    error={!this.state.descriptionValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                  <Typography className="h6 mt-32 mb-12">Coupon Discount</Typography>
                  <TextInput
                    id="coupon-discount"
                    model="coupon.discount"
                    placeholder="Price off (add % for percent off)"
                    required
                    error={!this.state.discountValid}
                    helperText={this.state.discountValid ? "Required Field *" : `Percentage or value between 1 and ${maxPriceOff}`}
                    validators={{
                      required: (val) => {
                        if ( isNumeric(`${val}`, false, maxPriceOff, true) ) {
                          return true
                        }
                        if ( `${val}`.match(/^\d+[ ]*%$/) ) {
                          return isNumeric(val.split(/%/)[0].trim(), false, 100)
                        }
                        return false
                      }
                    }}
                  />

                  <Typography className="h6 mt-32 mb-12">Max Usage (0=unlimited)</Typography>
                  <TextInput
                    id="coupon-limit"
                    model="coupon.limit"
                    placeholder="Max redeems (0 = unlimited)"
                    helperText={this.state.limitValid ? "Required Field *" : "Greater than or equal to 0"}
                    error={!this.state.limitValid}
                    validators={{
                      required: (val) => {
                        return isNumeric(val, true)
                      }
                    }}
                  />

                  <Typography className="h6 mt-32 mb-12">Valid dates</Typography>
                  <Grid item container xs={12} spacing={24}>
                    <Grid item xs={12} md={4}>
                      <DateInput
                        id="coupon-valid_from"
                        model="coupon.valid_from"
                        error={!this.state.valid_fromValid}
                        placeholder="From"
                        onChange={this.onChangeFrom.bind(this)}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <DateInput
                        id="coupon-valid_to"
                        model="coupon.valid_to"
                        error={!this.state.valid_toValid}
                        placeholder="To"
                        onChange={this.onChangeTo.bind(this)}
                      />
                    </Grid>
                  </Grid>

                </div>
              </Paper>
            </LocalForm>

            <Hidden smDown>
              <div className="d-flex justify-content-end mt-40">
                { actionButtons }
              </div>
            </Hidden>
          </Grid>

          { actionName === "update" && (
            <Grid item xs={12} md={4} className="will-change3">

              <Paper>
                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                    <div className="mb-12 c-black087 body2">
                      <span className="d-inline-block fw-bold min-width-100">Status:</span>{capitalize(status)}
                    </div>

                    <MetaBox
                      title="ID"
                      value={id}
                    />
                    {
                      !business_id && (
                        <MetaBox
                          title="Redeemed"
                          value={`${usage} times`}
                        />
                      )
                    }

                    {
                      (business_id && (
                        <React.Fragment>
                          <MetaBox
                            title="Business"
                            value={`${business_name}`}
                          />

                          <MetaBox
                            title="Invites"
                            value={`${vouchers}`}
                          />
                          <MetaBox
                            title="Redeems"
                            value={`${consumed_vouchers}`}
                          />
                          <MetaBox
                            title="Campaign Token"
                            value={`${campaign_token}`}
                          />
                        </React.Fragment>
                      ))
                    }
                    <MetaBox
                      title="Created by"
                      value={creator && creator.name}
                    />
                    <MetaBox
                      title="Created on"
                      value={new Date(created_at).toLocaleString()}
                    />
                    { updated_at && (<MetaBox
                      title="Modified on"
                      value={new Date(updated_at).toLocaleString()}
                    />)}
                    { published_on && (<MetaBox
                      title="Published on"
                      value={new Date(published_on).toLocaleString()}
                    />)}

                  </div>
                </div>

                <Divider className="bg-divider" />

                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                  <div className="fw-bold body2">Actions:</div>
                    {
                        status === 'draft' && (
                          <React.Fragment>

                            <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                                e.preventDefault()
                                if (this.checkValid()) {
                                  this.setState({showDialog:true})
                                }
                            }}>Publish Coupon</Link>

                            <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=> {
                              e.preventDefault()
                              if (this.checkValid()) {
                                this.setState({showRevokeDialog:true})
                              }
                            }}>Revoke Coupon</Link>

                            {
                              usage !== undefined && usage > 0 && (
                                <Link to={`/tests/coupon?coupon_id=${longid}`} className="c-black087 body2 d-block mb-8" target="_blank">
                                  Redeemed Instances
                                </Link>
                              )
                            }

                          </React.Fragment>
                        )
                      }

                  </div>
                </div>
              </Paper>

              <CustomDialog
                id={`publish-dialog`}
                qid={id}
                isopen={this.state.showDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handlePublish.bind(this)}
                fullScreen = {false}
                title={`Publish Coupon?`}
              >
                Do you want to save changes and publish this coupon?
              </CustomDialog>
              <CustomDialog
                id={`revoke-dialog`}
                qid={id}
                isopen={this.state.showRevokeDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handleRevoke.bind(this)}
                fullScreen = {false}
                title={`Revoke Coupon?`}
              >
                Do you want to save changes and revoke this coupon?
              </CustomDialog>
            </Grid>
          )}
        </Grid>

      </MuiThemeProvider>
    )
  }
}

const CouponForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedCouponForm)
export default CouponForm



// WEBPACK FOOTER //
// ./src/js/components/CouponForm.js